import { PortfolioApprovalDetails } from './portfolios-approvals/portfolio-approval-details/portfolio-approval-details';
import { Routes } from '@angular/router';

export const pendingApprovalsRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'service-approvals',
      },
      {
        path: 'service-approvals',
        loadComponent: () =>
          import('./services-approvals/services-approvals').then((m) => m.ServicesApprovals),
      },
      {
        path: 'service-approvals/:id',
        data: { context: 'pending-approvals' },
        loadComponent: () =>
          import('./services-approvals/service-details/service-details').then(
            (m) => m.ServiceDetails,
          ),
      },
      {
        path: 'portfolio-approvals',
        loadComponent: () =>
          import('./portfolios-approvals/portfolios-approvals').then((m) => m.PortfoliosApprovals),
      },

      {
        path: 'portfolio-approvals/:id',
        loadComponent: () =>
          import('./portfolios-approvals/portfolio-approval-details/portfolio-approval-details').then((m) => m.PortfolioApprovalDetails),
      },

      {
        path: 'project-approvals',
        loadComponent: () =>
          import('./projects-approvals/projects-approvals').then((m) => m.ProjectsApprovals),
      },
      {
        path: 'project-approvals/:id',
        loadComponent: () =>
          import('./projects-approvals/project-approval-details/project-approval-details').then((m) => m.ProjectApprovalDetails),
      },
    ],
  },
];
